import { BaseIcon, BaseIconProps } from '../BaseIcon';
import { joinClassNames } from '../../../../utils';
import styles from './styles.scss';

export type ChevronLeftIconProps = Omit<BaseIconProps, 'children'>;

export const ChevronLeftIcon = ({ className, ...props }: ChevronLeftIconProps) => (
  <BaseIcon
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    className={joinClassNames(styles.chevronLeft, className)}
    {...props}
  >
    <path d="M1 4L0.646447 3.64645C0.552678 3.74021 0.5 3.86739 0.5 4C0.5 4.13261 0.552678 4.25978 0.646447 4.35355L1 4ZM3.64645 0.646447L0.646447 3.64645L1.35355 4.35355L4.35355 1.35355L3.64645 0.646447ZM0.646447 4.35355L3.64645 7.35355L4.35355 6.64645L1.35355 3.64645L0.646447 4.35355Z" />
  </BaseIcon>
);

ChevronLeftIcon.displayName = 'ChevronLeftIcon';
